import { styled } from 'styled-components';
import { Tabs } from 'antd';
import { media } from 'src/utils/mediaQueryUtils';
import { COMMON_COLORS } from '@neteera/neteera-web-nextgen';

export const PageContentWrapper = styled.div`
  min-height: calc(100% - 74px);
`;

export const StyledTabs = styled(Tabs)`
  overflow: auto;
  display: block;
  color: ${COMMON_COLORS.greyDark};
  height: 100%;
  .ant-tabs-nav {
    margin: 0;
    padding: 1%;
    background-color: ${props =>
      props.theme.colors.individualDashboardBackground};
    ${media.small`
      padding: 0 1% 3px;
    `}
    ${media.extraLarge`
      padding: 0px 30px 5px;
    `}
  }
  .ant-tabs-nav-list {
    align-items: center;
    .ant-tabs-tab {
      margin: 0;
      border-radius: 40px;

      ${media.small`
      font-size: 14px;
      padding: 5px 8px;
    `}
      ${media.extraLarge`
      font-size: 16px;
      padding: 11px 16px;
    `}
    }
    .ant-tabs-tab-active {
      background-color: ${COMMON_COLORS.teal200} !important;
      padding: 10px 16px;
      font-weight: 500;
      line-height: 1.25;

      .ant-tabs-tab-btn {
        color: ${COMMON_COLORS.greyDark} !important;
      }
    }
    .ant-tabs-ink-bar {
      display: none;
    }
  }
`;
